export default __webpack_public_path__ + "static/media/reincarnation.494572e4.png";